import {takeEvery} from 'redux-saga/effects'

import {
  CREATE_MONTHLY_AUDIT_SUMMARY,
  DELETE_ALL_MONTHLY_AUDIT_SUMMARY,
  GET_MONTHLY_AUDIT_SUMMARY,
} from '../../Actions/MonthlyAuditSummary/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_MONTHLY_AUDIT_SUMMARY, fetchData)
  yield takeEvery(CREATE_MONTHLY_AUDIT_SUMMARY, fetchData)
  yield takeEvery(DELETE_ALL_MONTHLY_AUDIT_SUMMARY, fetchData)
}

export default dataSaga
